import React from "react";

export class CreateTeamForm extends React.Component {
    static getDerivedStateFromProps(props, state) {
        const { submitted, form } = state;
        const { defaultForm, logoUrl } = props;

        let newState = null;

        if (submitted && defaultForm) {
            newState = {
                submitted: false,
                form: {
                    name: '',
                    logo: ''
                }
            };
        }

        if (logoUrl && form.logo !== logoUrl) {
            newState = newState ? { ...newState } : { ...state }; 
            newState.form = {
                ...newState.form,
                logo: logoUrl
            };
        }

        return newState;
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            form: {
                name: '',
                logo: '',
            },
            submitted: false
        };
    }

    render() {
        const { form, submitted } = this.state;
        const { uploadingLogo, onFileChange, onUploadButtonClick, fileInputRef } = this.props;

        return (
            <form name="teamForm" onSubmit={this._onSubmit}>
                <div className={'form-group mb-16' + (submitted && !form.name ? ' has-error' : '')}>
                    <div class="input-wrapper">
                        <input type="text"
                                className="form-control"
                                name="name"
                                value={form.name}
                                placeholder="Enter team name"
                                onChange={this._handleNameChange} />
                        <button type="button" className="close-btn" aria-label="Close" onClick={() => {
                                this.setState({
                                    form: {
                                        name: ''
                                    },
                                    submitted: false
                                });
                            }}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    {submitted && !form.name &&
                        <div className="help-block">Team name is required</div>
                    }              
                </div>

                <div>
                    <input
                        type="file"
                        onChange={onFileChange}
                        ref={fileInputRef}
                        accept="image/*"
                        style={{ display: 'none' }}
                    />

                    <button
                        type="button"
                        className="btn btn-primary mb-16"
                        style={{ background: '#58585A'}}
                        onClick={onUploadButtonClick}
                        disabled={uploadingLogo}
                    >
                        Upload Team Logo
                    </button>
                </div>

                <div>
                    <button type="submit" className="btn btn-primary">Save</button>
                    <button
                        className="btn btn-link ms-16"
                        type="button"
                        onClick={this._resetTeam}
                    >
                        Cancel
                    </button>
                </div>

            </form>
        );
    }

    _onSubmit = (event) => {
        event.preventDefault();

        this.setState({
            submitted: true
        });
        const { form } = this.state;

        if (form.name && form.logo) {
            this.props.onSave(form);
        } else {
            console.log("Form is not valid. Name and/or Logo missing.");
        }
    }

    _resetTeam = () => {
        this.setState({
            form: {
                name: '',
                logo: '' 
            },
            submitted: false 
        });

        if (this.props.fileInputRef && this.props.fileInputRef.current) {
             this.props.fileInputRef.current.value = null;
        }
    }

    _handleNameChange = (event) => {
        const { form } = this.state;
        this.setState({
            form: {
                ...form,
                name: event.target.value
            }
        });
    }
}
